export const TrackEvents = {
    FULL_POLICY_VIEWED: `cookie-policy-viewed`,
    BANNER_SHOWN: `cookie-policy-banner-shown`,
    POLICY_ACKNOWLEDGED: `cookie-policy-acknowledged`,
} as const